import { Chakra } from "@airhelp/react-ui-components";
import config from "config/config";

import { useTranslations } from "contexts/LocalizationContext";

const { Image, Flex, Text } = Chakra;

const ApraInfo = () => {
  const translations = useTranslations();

  return (
    <Flex flexDirection="column">
      <Image
        src={`${config.staticUrl}/i/airhelp-plus/apra-logo.svg`}
        alt={translations("alt_logo_apra")}
        htmlWidth="120px"
        htmlHeight="29px"
        width="120px"
        maxWidth="initial"
        mr={8}
        mb={4}
        loading="lazy"
      />
      <Text color="greyscale.600" fontSize="sm">
        {translations("footer_airhelp_is_part")}
      </Text>
    </Flex>
  );
};

export default ApraInfo;
